import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Motion";

/**
 * Large CTA banner with dark background, used at the bottom of key pages.
 */
export default function CtaBanner({
  eyebrow = "Next Step",
  title = "Let's build your next chapter together.",
  body = "Whether you're modernizing a stack, training a team, or hiring engineers — we're ready when you are.",
  primary = { to: "/contact", label: "Book a Consultation" },
  secondary = { to: "/services", label: "Explore Services" },
}) {
  return (
    <section data-testid="cta-banner" className="bg-slate-950 text-white relative overflow-hidden">
      <div className="absolute inset-0 grid-lines-dark opacity-60" />
      <div className="absolute -top-24 -right-20 w-[420px] h-[420px] bg-emerald-500/10 blur-3xl rounded-full" />
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <Reveal>
          <div className="eyebrow text-emerald-400">{eyebrow}</div>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-5 font-display text-4xl md:text-5xl lg:text-6xl font-semibold max-w-3xl leading-[1.05] tracking-tight">
            {title}
          </h2>
        </Reveal>
        <Reveal delay={0.14}>
          <p className="mt-6 text-slate-300 text-lg max-w-2xl leading-relaxed">{body}</p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <Link
              to={primary.to}
              data-testid="cta-banner-primary"
              className="group inline-flex items-center gap-2 bg-emerald-500 text-slate-950 px-8 py-4 font-medium hover:bg-emerald-400 transition-colors"
            >
              {primary.label}
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.75} />
            </Link>
            <Link
              to={secondary.to}
              data-testid="cta-banner-secondary"
              className="inline-flex items-center gap-2 border border-slate-700 text-white px-8 py-4 font-medium hover:border-emerald-500 hover:text-emerald-400 transition-colors"
            >
              {secondary.label}
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
